import React from 'react';

import { Box } from '@mui/material';
import _ from 'lodash';
import Moment from 'moment';
import styled from 'styled-components';

interface LogItem {
    level: string;
    message: string;
    metadata: any;
    timestamp: string;
}

interface Props {
    item: LogItem;
    setSearchText?: (searchText: string) => void;
}

const HoverableDiv = styled.td`
    &:hover {
        cursor: pointer;
    }
`;

const Generic: React.FC<Props> = ({ item, setSearchText }) => {
    const fromElement = (
        <>
            <div style={{ position: 'absolute', top: '-5px', right: '5px', fontSize: '10px' }}>
                {Moment(new Date(item.timestamp)).format('h:mm A')}
            </div>
        </>
    );
    let traceElement = <></>;
    if (item.metadata && item.metadata.trace_id) {
        const traceAttributes = item.metadata.trace_id.split(',');
        traceElement = (
            <>
                <table style={{ marginTop: '12px', marginBottom: '12px', width: '100%', fontSize: '12px' }}>
                    <tr>
                        {traceAttributes.map((traceAtt: string) => {
                            const keyName = traceAtt.split(':')[0];
                            const keyValue = traceAtt.split(':')[1];
                            return (
                                <HoverableDiv
                                    onClick={() => {
                                        console.log('onClick', traceAtt);
                                        if (setSearchText) {
                                            setSearchText(traceAtt);
                                        }
                                    }}
                                    style={{ lineHeight: '12px' }}
                                >
                                    {keyName}
                                    <br />
                                    {keyValue}
                                </HoverableDiv>
                            );
                        })}
                    </tr>
                </table>
            </>
        );
    }
    const metaData = _.cloneDeep(item.metadata);
    delete metaData.trace_id;
    return (
        <Box
            sx={{
                overflow: 'scroll',
                position: 'relative',
                fontFamily: 'Lato',
                fontSize: '12px',
                marginBottom: '16px',
                width: '100%',
                padding: '3px',
                backgroundColor: 'rgb(255,255,255)',
                border: '1px solid rgb(230,230,230)',
                borderRadius: '4px'
            }}
        >
            {fromElement}
            {traceElement}
            <div
                style={{
                    fontSize: '13px',
                    position: 'relative',
                    left: '0px',
                    width: 'calc(100% - 0px)',
                    color: 'rgb(0,0,0)',
                    lineHeight: '1.0'
                }}
            >
                <div style={{ fontWeight: 'bolder' }}>{item.message}</div>
                <div>
                    <pre>{JSON.stringify(metaData, null, 2)}</pre>
                </div>
            </div>
        </Box>
    );
};

export default Generic;
